import { render, staticRenderFns } from "./salesman.vue?vue&type=template&id=1f77d52a&scoped=true"
import script from "./salesman.vue?vue&type=script&lang=js"
export * from "./salesman.vue?vue&type=script&lang=js"
import style0 from "./salesman.vue?vue&type=style&index=0&id=1f77d52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f77d52a",
  null
  
)

export default component.exports